import MainButton from '@/components/ui/custom/buttons/MainButton';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { FunnelIcon } from '@heroicons/react/20/solid';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationFiltersForm from './NotificationLeftFiltersForm';
import { twMerge } from 'tailwind-merge';

const NotificationMobileFilter = (props: ComponentProps<'aside'>) => {
  const { t: tPage } = useTranslation('translation', {
    keyPrefix: 'alerts.page',
  });

  return (
    <aside className={twMerge('md:hidden', props.className)} {...props}>
      <Tooltip
        color="white"
        className="p-3 rounded-md w-[250px]"
        options={{
          placement: 'bottom-end',
          interactive: true,
          delayHide: 200,
        }}
        text={<NotificationFiltersForm />}
      >
        <MainButton
          color="custom"
          text={tPage('filters').toLowerCase()}
          icon={<FunnelIcon className="w-4 h-4" />}
          className="flex-row-reverse gap-1"
        />
      </Tooltip>
    </aside>
  );
};

export default NotificationMobileFilter;
